// Safari versions that still reach the site have no AbortSignal.any. They sit below the
// browserslist floor, so eslint-plugin-compat does not flag a native call site as an error.

/**
 * Aborts the target when the source aborts, and carries the abort reason across.
 * Attach every listener on the target signal before you call this, because an already
 * aborted source aborts the target at once.
 * @param {AbortSignal} source
 * @param {AbortController} target
 * @returns {function(): void} Stops the forwarding. An abort of the target also stops it.
 */
export function forwardAbort(source, target) {
    const abort = () => target.abort(source.reason);
    const stop = () => source.removeEventListener('abort', abort);
    target.signal.addEventListener('abort', stop, {once: true});
    if (source.aborted) {
        abort();
    } else {
        source.addEventListener('abort', abort, {once: true});
    }

    return stop;
}
